import { Params } from '../FeatureStore';

function decodeSafe(raw: string) {
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function isJwtState(state: string | undefined) {
  if (!state) return false;

  const decoded = decodeSafe(state).trim();

  // Filter out JSON state objects (featureBranch/apiEnv flow)
  if (decoded.startsWith('{')) return false;

  const parts = decoded.split('.');
  if (parts.length < 3) return false;

  const base64Url = /^[A-Za-z0-9_-]+$/;
  return parts.every((p) => base64Url.test(p));
}

export function hasFHIRLaunchParams(
  params: Pick<Params, 'launch' | 'iss' | 'code' | 'state' | 'launchType'>
) {
  const { launch, iss, code, state, launchType } = params;

  const hasLaunchRequest =
    typeof launch === 'string' && launch.length > 0 && typeof iss === 'string' && iss.length > 0;

  // FHIR authorization code responses should either carry a launchType we set
  // (pcm/call) or a JWT-shaped state token issued by our FHIR service.
  const hasLaunchType = typeof launchType === 'string' && launchType.length > 0;

  const hasCodeExchangeParams =
    typeof code === 'string' &&
    code.length > 0 &&
    typeof state === 'string' &&
    state.length > 0 &&
    (hasLaunchType || isJwtState(state));

  return hasLaunchRequest || hasCodeExchangeParams;
}
